import Type from './Type';
export function isISeparator(node) {
    return node.type === Type.Separator;
}
export default isISeparator;    //# sourceMappingURL=isISeparator.js.map
